const Components = (cssVar: Record<string, string>) =>
{

    return {
        "Layout": {
            "colorBgLayout": cssVar[ '--layout_colorBgLayout' ],
        },
        "menu": {
            "colorBgContainer": "red",
            "colorBgContainerHover": "orange",
        },
        "Switch": {
            "colorPrimary": cssVar[ '--switch_colorPrimary' ],
            "colorPrimaryHover": cssVar[ '--switch_colorPrimaryHover' ],
            "colorTextQuaternary": cssVar[ '--switch_colorTextQuaternary' ],
            "colorTextTertiary": cssVar[ '--switch_colorTextTertiary' ],
        },
        "Typography": {
            // "colorText": cssVar[ '--typography_colorText' ],
            "colorBgLayout": cssVar[ '--typography_colorTextHeading' ],
            // "colorText": "",
        },
        "Table": {
            "borderRadius": 0,
            "borderRadiusLG": 0,
            "controlHeight": 32,
            "controlInteractiveSize": 18,
            "fontSizeIcon": 10,
            "padding": 12,
            "paddingContentVerticalLG": 4,
            "colorBgContainer": cssVar[ '--table_colorBgContainer' ],
            "colorBorderSecondary": cssVar[ '--table_colorBorderSecondary' ],
            "colorFillContent": cssVar[ '--table_colorFillContent' ],
            "colorLinkHover": cssVar[ '--table_colorLinkHover' ],
            "colorLink": cssVar[ '--table_colorLink' ],
            "colorPrimary": cssVar[ '--table_colorPrimary' ],
            "colorText": cssVar[ '--table_colorText' ],
            "colorTextHeading": cssVar[ '--table_colorTextHeading' ],
            "colorIcon": cssVar[ '--table_colorIcon' ],
            "colorIconHover": cssVar[ '--table_colorIconHover' ],
            "colorFillAlter": cssVar[ '--table_colorFillAlter' ],
        },
        "Button": {
            "borderRadius": 4,
            "fontSize": 16,
            "fontSizeLG": 18,
            "fontSizeSM": 14,
            "paddingContentHorizontal": 16,
            "controlHeight": 34,
            "colorBorder": cssVar[ '--button_colorBorder' ],
            "colorPrimaryActive": cssVar[ '--button_colorPrimaryActive' ],
            "colorPrimaryHover": cssVar[ '--button_colorPrimaryHover' ],
            "colorText": cssVar[ '--button_colorText' ],
            "colorBgContainer": cssVar[ '--button_colorBgContainer' ],
            "colorBgContainerDisabled": cssVar[ '--button_colorBgContainerDisabled' ],
            "colorBgTextHover": cssVar[ '--button_colorBgTextHover' ],
            "colorBgTextActive": cssVar[ '--button_colorBgTextActive' ],
            "colorTextLightSolid": cssVar[ '--button_colorTextLightSolid' ],
            "colorTextDisabled": cssVar[ '--button_colorTextDisabled' ],
        },
        "Form": {
            "fontSize": 12,
        },
        "Input": {
            "borderRadius": 4,
            "lineHeight": 1.5,
            "lineHeightLG": 2,
            "paddingLG": 20,
            "paddingSM": 11,
            "controlPaddingHorizontal": 10,
            "controlHeight": 34,
            "colorBgContainer": cssVar[ '--input_colorBgContainer' ],
            "colorBgContainerDisabled": cssVar[ '--input_colorBgContainerDisabled' ],
            "colorTextDisabled": cssVar[ '--input_colorTextDisabled' ],
            "colorBorder": cssVar[ '--input_colorBorder' ],
            "colorError": cssVar[ '--input_colorError' ],
            "colorPrimary": cssVar[ '--input_colorPrimary' ],
            "colorPrimaryActive": cssVar[ '--input_colorPrimaryActive' ],
            "colorText": cssVar[ '--input_colorText' ],
            "colorTextPlaceholder": cssVar[ '--input_colorTextPlaceholder' ],
        },
        "InputNumber": {
            "borderRadius": 4,
            "lineHeight": 1.5,
            "lineHeightLG": 2,
            "paddingLG": 20,
            "paddingSM": 11,
            "controlPaddingHorizontal": 10,
            "controlHeight": 34,
            "colorBgContainer": cssVar[ '--input_colorBgContainer' ],
            "colorBgContainerDisabled": cssVar[ '--input_colorBgContainerDisabled' ],
            "colorTextDisabled": cssVar[ '--input_colorTextDisabled' ],
            "colorBorder": cssVar[ '--input_colorBorder' ],
            "colorError": cssVar[ '--input_colorError' ],
            "colorPrimary": cssVar[ '--input_colorPrimary' ],
            "colorPrimaryActive": cssVar[ '--input_colorPrimaryActive' ],
            "colorText": cssVar[ '--input_colorText' ],
            "colorTextPlaceholder": cssVar[ '--input_colorTextPlaceholder' ],
        },
        "InputTextArea": {
            "lineHeight": 1.5,
        },
        "Select": {
            "controlHeight": 34,
            "colorBgContainer": cssVar[ '--select_colorBgContainer' ],
            "colorBgContainerDisabled": cssVar[ '--select_colorBgContainerDisabled' ],
            "colorText": cssVar[ '--select_colorText' ],
            "colorTextDescription": cssVar[ '--select_colorTextDescription' ],
            "colorTextPlaceholder": cssVar[ '--select_colorTextPlaceholder' ],
            "controlItemBgActive": cssVar[ '--select_controlItemBgActive' ],
            "colorBgElevated": cssVar[ '--select_colorBgElevated' ],
            "colorBorder": cssVar[ '--select_colorBorder' ],
            "colorTextDisabled": cssVar[ '--select_colorTextDisabled' ],
            "colorTextQuaternary": cssVar[ '--select_colorTextQuaternary' ],
            "colorFillSecondary": cssVar[ '--select_colorFillSecondary' ],
            "colorIcon": cssVar[ '--select_colorIcon' ],
            "fontWeightStrong": 600,
        },
        "Checkbox": {
            "fontSize": 14,
            "colorBgContainer": cssVar[ '--checkbox_colorBgContainer' ],
            "colorBorder": cssVar[ '--checkbox_colorBorder' ],
            "colorText": cssVar[ '--checkbox_colorText' ],
            "colorTextDisabled": cssVar[ '--checkbox_colorTextDisabled' ],
            "colorBgContainerDisabled": cssVar[ '--checkbox_colorBgContainerDisabled' ],
            "controlInteractiveSize": 24,
            "lineWidthBold": 3,
            "paddingXS": 12,
        },
        "Radio": {
            "radioSize": 24,
            "dotSize": 10,
        },
        "Dropdown": {
            "colorText": cssVar[ '--dropdown_colorText' ],
            "controlItemBgHover": cssVar[ '--dropdpwn_controlItemBgHover' ],
            "controlHeight": 32
        },
        "Breadcrumb": {
            "lastItemColor": cssVar[ '--breadcrumb_lastItemColor' ],
            "itemColor": cssVar[ '--breadcrumb_itemColor' ],
            "linkColor": cssVar[ '--breadcrumb_linkColor' ],
            "linkHoverColor": cssVar[ '--breadcrumb_linkHoverColor' ],
            "separatorColor": cssVar[ '--breadcrumb_separatorColor' ],
            "colorBgTextHover": cssVar[ '--breadcrumb_colorBgTextHover' ],
            "separatorMargin": 5,
            "fontSize": 12,
            "fontSizeIcon": 10
        },
        "Modal": {
            "padding": 5,
            "colorIcon": cssVar[ '--modal_colorIcon' ],
            "colorIconHover": cssVar[ '--modal_colorIconHover' ],
            "colorText": cssVar[ '--modal_colorText' ],
            "colorTextHeading": cssVar[ '--modal_colorTextHeading' ],
        },
        "Pagination": {
            "itemActiveBg": cssVar[ '--pagination_itemActiveBg' ],
            "colorText": cssVar[ '--pagination_colorText' ],
            "colorPrimary": cssVar[ '--pagination_colorPrimary' ],
            "colorPrimaryBorder": cssVar[ '--pagination_colorPrimaryBorder' ],
            "colorBgTextHover": cssVar[ '--pagination_colorBgTextHover' ],
            "borderRadius": 50,
        }

    };
};


export default Components;